"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubMenuItem = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var ExternalIcon_1 = __importDefault(require("../../Icons/ExternalIcon"));
require("./SubMenuItem.css");
/**
 * @deprecated Should start using the same component migrated to UI2.
 */
var SubMenuItem = function (props) {
    var title = props.title, description = props.description, href = props.href, isExternal = props.isExternal, className = props.className, eventTrackingName = props.eventTrackingName, onClickMenuOption = props.onClickMenuOption;
    var handleClick = (0, react_1.useCallback)(function (event) {
        event.preventDefault();
        onClickMenuOption &&
            onClickMenuOption(event, { eventTrackingName: eventTrackingName, url: href, isExternal: isExternal });
        setTimeout(function () {
            window.open(href, isExternal ? '_blank' : '_self', 'noopener');
        }, onClickMenuOption ? 300 : 0);
    }, [onClickMenuOption, eventTrackingName, href, isExternal]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('dui-submenu-item', className, isExternal && 'dui-submenu-item-external') },
        react_1.default.createElement("a", { href: href, onClick: handleClick },
            react_1.default.createElement("h1", null, title),
            react_1.default.createElement("p", null, description),
            isExternal && react_1.default.createElement(ExternalIcon_1.default, null))));
};
exports.SubMenuItem = SubMenuItem;
